import { v4 as uuidv4 } from 'uuid';
import { CollectionEntryValue } from './collection-entry.model';
/**
 * @TODO Important !!!
 * We don't have to extends the CollectionEntryValue
 * We can just use the TreeNode interface that primeNg uses
 */
export interface CollectionEntryTreeValue extends CollectionEntryValue {
  label?: string;
  data?: CollectionEntryValue;
  children?: CollectionEntryTreeValue[];
  id: string;
  relativeIndex?: string;
  type: string;
  selectable?: boolean;
  expanded: boolean;
}

/**
 * @TODO Should implement TreeNode Interface
 */
export class CollectionEntryTreeValueModel {
  label?: string;
  data?: CollectionEntryTreeValue;
  children?: CollectionEntryTreeValueModel[];
  id: string;
  relativeIndex?: string;
  value: any;
  level?: number;
  parent?: string | CollectionEntryTreeValueModel;
  index: number;
  type: string;
  selectable: boolean;
  expanded: boolean;
  draggable?: boolean;
  droppable?: boolean;
  constructor(entryValue: any) {
    this.label = entryValue?.label || null;
    this.children = entryValue?.children || [];
    this.id = entryValue?.id || uuidv4();
    this.data = entryValue?.data || this.id;
    this.relativeIndex = entryValue?.relativeIndex || null;
    this.value = entryValue?.value || null;
    this.level = entryValue?.level || null;
    this.parent = entryValue?.parent || null;
    this.index = entryValue?.index || null;
    this.type = entryValue?.type || 'default';
    this.expanded = false;
    if (this.type === 'emptyItem') {
      this.selectable = false;
      this.draggable = false;
      this.droppable = false;
    }
  }

  activateTreeItem(): void {
    this.selectable = true;
    this.type = 'default';
    this.draggable = true;
    this.droppable = true;
  }
}
